export interface NotificationKeyParams {
  user: string;
  country: string;
}

export const notificationKeys = {
  root: (params: NotificationKeyParams) =>
    ['notification', params.user, params.country] as const,
  read: (params: NotificationKeyParams) =>
    [...notificationKeys.root(params), 'read'] as const,
  unread: (params: NotificationKeyParams) =>
    [...notificationKeys.root(params), 'unread'] as const,
};

export function parseNotificationKey<T extends keyof typeof notificationKeys>(
  queryKey: ReturnType<(typeof notificationKeys)[T]>,
): NotificationKeyParams {
  const [, user, country] = queryKey;

  return { user, country };
}
